var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("pagination",[_c('r-pagination-control',{attrs:{"pagination":_vm.pagination}})],{"pagination":_vm.pagination})],2)}
var staticRenderFns = []

export { render, staticRenderFns }